import { initialAgents } from './agents.js';

export const CHANNEL_TYPES = ['telegram', 'whatsapp', 'email', 'sms'];

const CHANNEL_DETAILS = {
  telegram: {
    name: 'Telegram',
    handle: '@agi_agency_bot',
    description: 'Approvals, escalations, and on-call pings.'
  },
  whatsapp: {
    name: 'WhatsApp Business',
    handle: '+1 555 0142',
    description: 'Client-facing notifications and human handoff.'
  },
  email: {
    name: 'Email',
    handle: 'ops@agi-agency.io',
    description: 'Digests, invoices, and low-urgency routing.'
  },
  sms: {
    name: 'SMS',
    handle: '+1 555 0188',
    description: 'Critical alerts only — kill-switch events.'
  }
};

export const initialChannels = CHANNEL_TYPES.map((type, index) => ({
  id: `ch-${type}`,
  type,
  ...CHANNEL_DETAILS[type],
  status: ['connected', 'connected', 'degraded', 'connected'][index],
  unread: [3, 1, 0, 0][index],
  messagesToday: [142, 37, 89, 4][index],
  deliveryRate: [0.994, 0.981, 0.997, 0.988][index],
  lastEventAt: Date.now() - [2, 9, 26, 118] * 60 * 1000,
  enabledAgentIds: index === 0 ? initialAgents.map((agent) => agent.id) : [1, 3, 6]
}));

export const initialRoutingRules = [
  {
    id: 'rule-1',
    enabled: true,
    agentId: 6,
    event: 'compliance_violation',
    channelType: 'sms',
    target: '+1 555 0188'
  },
  {
    id: 'rule-2',
    enabled: true,
    agentId: 1,
    event: 'approval_required',
    channelType: 'telegram',
    target: '@sarah-oncall'
  },
  {
    id: 'rule-3',
    enabled: false,
    agentId: 4,
    event: 'task_failed',
    channelType: 'email',
    target: 'eng@agi-agency.io'
  }
];

export const ROUTING_EVENTS = [
  { value: 'approval_required', label: 'Approval required' },
  { value: 'compliance_violation', label: 'Compliance violation' },
  { value: 'task_failed', label: 'Task failed' },
  { value: 'task_completed', label: 'Task completed' },
  { value: 'budget_threshold', label: 'Budget threshold crossed' }
];

export const initialChannelMessages = [
  {
    id: 'msg-1',
    channelType: 'telegram',
    direction: 'outbound',
    agentId: 1,
    preview: 'Atlas: Approval APR-2841 needs review — campaign spend $36K.',
    status: 'delivered',
    timestamp: Date.now() - 4 * 60 * 1000
  },
  {
    id: 'msg-2',
    channelType: 'whatsapp',
    direction: 'inbound',
    agentId: 8,
    preview: 'Client Acme: "Can you re-run the weekly report?" — escalated.',
    status: 'delivered',
    timestamp: Date.now() - 16 * 60 * 1000
  },
  {
    id: 'msg-3',
    channelType: 'sms',
    direction: 'outbound',
    agentId: 6,
    preview: 'Sentinel: compliance scan failed on ledger sync. Investigating.',
    status: 'delivered',
    timestamp: Date.now() - 42 * 60 * 1000
  },
  {
    id: 'msg-4',
    channelType: 'email',
    direction: 'outbound',
    agentId: 9,
    preview: 'Ledger: weekly ROI digest sent to 3 client contacts.',
    status: 'queued',
    timestamp: Date.now() - 55 * 60 * 1000
  },
  {
    id: 'msg-5',
    channelType: 'whatsapp',
    direction: 'outbound',
    agentId: 8,
    preview: 'Support: refund workflow completed for Helios Ltd.',
    status: 'failed',
    timestamp: Date.now() - 75 * 60 * 1000
  }
];

export const RATE_LIMITS = [
  { channelType: 'telegram', limit: 30, window: 'per second', usage: 0.21 },
  { channelType: 'whatsapp', limit: 80, window: 'per minute', usage: 0.46 },
  { channelType: 'email', limit: 500, window: 'per hour', usage: 0.18 },
  { channelType: 'sms', limit: 10, window: 'per minute', usage: 0.62 }
];
